import React from "react";

import CosmosNotInstalled from "./CosmosNotInstalled";
import CosmosNotSetup from "./CosmosNotSetup";

const CosmosState = ({ isCosmosInstalled, isCosmosSetup, macro }) => {
  return (
    <>
      {!isCosmosInstalled && <CosmosNotInstalled macro={macro} />}
      {isCosmosInstalled && !isCosmosSetup && <CosmosNotSetup />}
    </>
  );
};

export default CosmosState;
